<div class="container-fluid">
  <div class="container text-center p-5">
    <h2 class="display-4 mb-5">Edit a dog details
      <i class="fa fa-paw" aria-hidden="true"></i><br>

    </h2>
    <form #f="ngForm" (ngSubmit)="editDog()" class="col-lg-6 mx-auto">
      <h5>Help me find a home</h5>
      <div>
        <div>
          <input name="name" [ngModel]="dogDetailsObj.name" #inputName="ngModel" ngModel type="text" class="form-control mt-3"
            >
          <div *ngIf="inputName.touched && inputName.invalid" class="text-danger text-start">Enter a valid name</div>
        </div>

        <input name="age" [ngModel]="dogDetailsObj.age" #inputAge="ngModel" ngModel type="email" class="form-control mt-3"
          >
        <div *ngIf="inputAge.touched && inputAge.invalid" class="text-danger text-start">Enter a valid age</div>
      </div>

      <div>
        <input name="breed" [ngModel]="dogDetailsObj.breed" #inputBreed="ngModel" ngModel type="text" class="form-control mt-3" 
          >
        <div *ngIf="inputBreed.touched && inputBreed.invalid" class="text-danger text-start">Enter a valid breed</div>
      </div>

      <div class="mt-3 text-start">
        <label>Dog's Size:</label>
        <select name="size" #dogSize="ngModel" ngModel  class="form-select" [ngModel]="dogDetailsObj.size">
        <option value="small">Small</option>    
        <option value="medium">Medium</option>    
        <option value="big">big</option>    
        </select>
      </div>

      <div class="mt-3 text-start">
        <select name="gender" [ngModel]="dogDetailsObj.gender" #dogGender="ngModel" ngModel  class="form-select">
        <option value="male">Male</option>    
        <option value="female">Female</option>    
        </select>
      </div>

<div>
  <textarea name="description" [ngModel]="dogDetailsObj.description" id="" cols="30" rows="5" #description="ngModel" ngModel  class="form-control mt-3" style="resize: none;"></textarea>
</div>

      <div>
        <input name="image" [ngModel]="dogDetailsObj.image" #inputImage="ngModel" ngModel type="text" class="form-control mt-3" >
        <div *ngIf="inputImage.touched && inputImage.invalid" class="text-danger text-start">Enter a valid Image</div>
      </div>
      <div>
        <button class="btn btn-warning w-100 mt-3">Save Me</button>
      </div>
      <div class="mt-5">
        <br>
        PetMe © 2021 - 2022
      </div>
    </form>
  </div>
</div>